<div class="modal-content">
  <div class="modal-header">
    <p class="modal-title"><strong>{{(data.type === 'DEADLINE' ? 'TASK_LIST_DEADLINE_MODIFICATION' : 'TASK_RECORD_CHANGE_AGREED_TIME')| translate}}</strong></p>
    <button type="button" class="close" (click)="closeDialog()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <mat-dialog-content style="overflow:visible">
      <form (ngSubmit)="save()" #f="ngForm" id="form"
            [formGroup]="formGroup" novalidate>
        <div class="form-group">
          <label class="form-control-label">{{ (data.type === 'DEADLINE' ? 'TASK_LABEL_DEADLINE' : 'TASK_RECORD_AGREED_TIME') | translate }}</label>
          <div>
            <div class="clearfix row">
              <div class="col-sm">
                <div class="row">

                  <div class="input-group col-md-6">
                    <input placeholder="{{'DATE_TIME_PICKER_PLACEHOLDER_DATE' | translate}}" type="text"
                           class="form-control"
                           [(ngModel)]="model.deadlineDate"
                           ngbDatepicker #date_picker="ngbDatepicker"
                           formControlName="deadlineDate">
                    <span class="add-on input-group-addon-gray" (click)="date_picker.toggle()">
                              <i class="icomoon icomoon-calendar"></i>
                            </span>
                  </div>
                  <div class="input-group col-md-6">
                    <input placeholder="{{'DATE_TIME_PICKER_PLACEHOLDER_TIME' | translate}}" type="text"
                           class="form-control hidden-value-when-disabled"
                           [(ngModel)]="model.deadlineTime"
                           formControlName="deadlineTime"
                           [seconds]="false"
                           [disabled]="model.deadlineDate === null"
                           [allowEmptyValue]="false"
                           ngbTimepicker #time_picker="ngbTimepicker"
                           [toggleButtonId]="'time_picker_toggle_button'"
                           [spinners]="true" [hourStep]="1" [minuteStep]="10">
                    <span class="add-on input-group-addon-gray"
                          id="time_picker_toggle_button"
                          (click)="time_picker.toggle()">
                              <i class="icomoon icomoon-time"></i>
                            </span>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>


      </form>
      <div class="container-vertical-padding-half"></div>
      <div class="alert alert-danger mb-0">
        <h6 class="alert-title">{{
            'TASK_LIST_APPROVE_DATA_MODIFICATION_MESSAGE' | translate: {
              count:
              data.taskRecordIds.size
            }
          }}</h6>
      </div>

    </mat-dialog-content>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" (click)="closeDialog()">
      {{'COMMON_BUTTON_CANCEL' | translate}}
    </button>
    <button type="submit" class="btn btn-primary" form="form">
      {{'COMMON_BUTTON_SAVE' | translate}}
    </button>
  </div>
</div>
